import { render, staticRenderFns } from "./CategoryScoring.vue?vue&type=template&id=c20bd70c&"
import script from "./CategoryScoring.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CategoryScoring.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports